"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteStreamEvm = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var core_1 = require("@moralisweb3/core");
var evm_utils_1 = require("@moralisweb3/evm-utils");
var name = 'DeleteStream';
var method = 'delete';
var apiToResult = function (apiData) {
    var data = (0, core_1.toCamelCase)(apiData);
    return __assign(__assign({}, data), { chains: data.chainIds.map(function (chainId) { return evm_utils_1.EvmChain.create(chainId); }) });
};
exports.deleteStreamEvm = (0, api_utils_1.createEndpointFactory)(function () {
    return (0, api_utils_1.createEndpoint)({
        name: name,
        getUrl: function (params) { return "/streams/evm/".concat(params.id); },
        apiToResult: apiToResult,
        resultToJson: function (data) { return (__assign(__assign({}, data), { chainIds: data.chains.map(function (chain) { return chain.format(); }) })); },
        parseParams: function (params) { return params; },
        method: method,
    });
});
